import React from 'react';
import * as MyCells from '../../../utils/Cells';
import ActionMenu from '../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../common/filters/Filters';
import MultiSelectColumnFilter from '../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';


export const columns = (refresh) => {
    return [
        {
            Header: 'Dátum',
            accessor: 'date',
            id: 'date',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Típus',
            accessor: 'pettyCashTypeLabel',
            id: 'pettyCashTypeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Partner',
            accessor: 'partner',
            id: 'partner',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Összeg',
            accessor: 'amount',
            id: 'amount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Záróegyenleg',
            accessor: 'balance',
            id: 'balance',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'cash'} refresh={refresh} />,
        },
    ]
}